module.exports = __webpack_public_path__ + "img/맥형띠배너_mobile.9936c20f.png";